import { Subject } from 'rxjs'
import apiResponse from '../../../../../services/apiResponse'
import CreateRepository from '../Repositories/CreateRepository'


class CreateBloc {

    // 
    detailPegawaiChannel = new Subject();
    createChannel = new Subject();
    detailChannel = new Subject();
    repository = new CreateRepository()
    employeeChannel = new Subject();
    rankChannel = new Subject();
    listPresensiChannel = new Subject();
    typeChannel = new Subject()
    deletePresensi = new Subject()
    generatePresensi = new Subject()
    updateJabatan = new Subject()
    listJabatanChannel = new Subject();
    flagRevChannel = new Subject();

    constructor() {
        this.createChannel.next({status: apiResponse.INITIAL})
        this.flagRevChannel.next({status: apiResponse.INITIAL})
        //this.listPresensiChannel.next({status: apiResponse.INITIAL})
    }

    fetchDetailPegawai = async (query) => {
        try {
            this.detailPegawaiChannel.next({status: apiResponse.LOADING})
            await this.repository.fetchdetailPegawaiChannel(query).then((result) => {
                this.detailPegawaiChannel.next({status: apiResponse.COMPLETED, data: result})
            }).catch((error) => {
                this.detailPegawaiChannel.next({status: apiResponse.ERROR, data: error})
            })
        } catch (error) { console.log("unsubscribed") }
    }
    fetchCreate = async (query) => {
        try {
            this.createChannel.next({status: apiResponse.LOADING})
            await this.repository.fetchCreate(query).then((result) => {
                this.createChannel.next({status: apiResponse.COMPLETED, data: result})
            }).catch((error) => {
                this.createChannel.next({status: apiResponse.ERROR, data: error})
            })
        } catch (error) { console.log("unsubscribed") }
    }

    fetchEmployee = async (query) => {
        try {
            this.employeeChannel.next({status: apiResponse.LOADING})
            await this.repository.fetchEmployee(query).then((result) => {
                this.employeeChannel.next({status: apiResponse.COMPLETED, data: result})
            }).catch((error) => {
                this.employeeChannel.next({status: apiResponse.ERROR, data: error})
            })
        } catch (error) { console.log("unsubscribed") }
    }
    fetchRank = async (query) => {
        try {
            this.rankChannel.next({status: apiResponse.LOADING})
            await this.repository.fetchRank(query).then((result) => {
                this.rankChannel.next({status: apiResponse.COMPLETED, data: result})
            }).catch((error) => {
                this.rankChannel.next({status: apiResponse.ERROR, data: error})
            })
        } catch (error) { console.log("unsubscribed") }
    }
    fetchType = async (query) => {
        try {
            this.typeChannel.next({status: apiResponse.LOADING})
            await this.repository.fetchType(query).then((result) => {
                this.typeChannel.next({status: apiResponse.COMPLETED, data: result})
            }).catch((error) => {
                this.typeChannel.next({status: apiResponse.ERROR, data: error})
            })
        } catch (error) { console.log("unsubscribed") }
    }

    fetchDetail = async (query) => {
        try {
            this.detailChannel.next({status: apiResponse.LOADING})
            await this.repository.fetchDetail(query).then((result) => {
                this.detailChannel.next({status: apiResponse.COMPLETED, data: result})
            }).catch((error) => {
                this.detailChannel.next({status: apiResponse.ERROR, data: error})
            })
        } catch (error) { console.log("unsubscribed") }
    }
    fetchListPresensi = async (query) => {
        try {
            this.listPresensiChannel.next({status: apiResponse.LOADING})
            await this.repository.fetchListPresensi(query).then((result) => {
                this.listPresensiChannel.next({status: apiResponse.COMPLETED, data: result})
            }).catch((error) => {
                this.listPresensiChannel.next({status: apiResponse.ERROR, data: error})
            })
        } catch (error) { console.log("unsubscribed") }
    }

    fetchDeletePresensi = async (query) => {
        try {
            this.deletePresensi.next({status: apiResponse.LOADING})
            await this.repository.fetchDeletePresensi(query).then((result) => {
                this.deletePresensi.next({status: apiResponse.COMPLETED, data: result})
            }).catch((error) => {
                this.deletePresensi.next({status: apiResponse.ERROR, data: error})
            })
        } catch (error) { console.log("unsubscribed") }
    }

    fetchGeneratePresensi = async (query) => {
        try {
            this.generatePresensi.next({status: apiResponse.LOADING})
            await this.repository.fetchGeneratePresensi(query).then((result) => {
                this.generatePresensi.next({status: apiResponse.COMPLETED, data: result})
            }).catch((error) => {
                this.generatePresensi.next({status: apiResponse.ERROR, data: error})
            })
        } catch (error) { console.log("unsubscribed") }
    }
    fetchUpdateJabatan = async (query) => {
        try {
            this.updateJabatan.next({status: apiResponse.LOADING})
            await this.repository.fetchUpdateJabatan(query).then((result) => {
                this.updateJabatan.next({status: apiResponse.COMPLETED, data: result})
            }).catch((error) => {
                this.updateJabatan.next({status: apiResponse.ERROR, data: error})
            })
        } catch (error) { console.log("unsubscribed") }
    }
    fetchListJabatan = async (query) => {
        try {
            this.listJabatanChannel.next({status: apiResponse.LOADING})
            await this.repository.fetchListJabatan(query).then((result) => {
                this.listJabatanChannel.next({status: apiResponse.COMPLETED, data: result})
            }).catch((error) => {
                this.listJabatanChannel.next({status: apiResponse.ERROR, data: error})
            })
        } catch (error) { console.log("unsubscribed") }
    }
    fetchFlagRev = async (query) => {
        try {
            this.flagRevChannel.next({status: apiResponse.LOADING})
            await this.repository.fetchFlagRev(query).then((result) => {
                this.flagRevChannel.next({status: apiResponse.COMPLETED, data: result})
            }).catch((error) => {
                this.flagRevChannel.next({status: apiResponse.ERROR, data: error})
            })
        } catch (error) { console.log("unsubscribed") }
    }

    
}

export default CreateBloc